import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class OrdersOfLogonUser
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: OrdersOfLogonUser.Params): Observable<OrdersOfLogonUser.Result[]>
	{
		return this.m_queryInvoker.doQuery("OrdersOfLogonUser", params);
	}
};

export namespace OrdersOfLogonUser
{
	export class Params
	{
		customerProxy?: string;
		txDateFrom?: Date;
		txDef?: string;
		txDateUntil?: Date;
		deliveryState?: number;
		articleProxy?: string;
		sortAttribute?: string;
		id?: string;
		name?: string;
		street?: string;
		zip?: string;
		city?: string;
		country?: string;
		trackingno?: string;
		hasTrackingnos?: boolean;
		onlyToAuthorize?: boolean;
		limit?: number;
		zbsConfig: string;
	};
	export interface Result
	{
		oid?: string;
		id?: string;
		txDate?: Date;
		creationDate?: Date;
		zip?: string;
		city?: string;
		orderValue?: number;
		currencyCode?: string;
		deliveryState?: number;
		txStateId?: number;
		alternateName?: string;
		freightageSurcharge?: number;
		trackingNumbers?: TrackingNumber[];
		zbsValuelistEntry?: string;
	};
	export interface TrackingNumber
	{
		id?: string;
		proxyName?: string;
		trackingLink?: string;
	};
};
